import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function Loading({ message }) {
  const { t } = useLanguage();
  return (
    <div className="loading">
      <div className="loading-spinner" />
      <p>{message || t('defaultLoading')}</p>
    </div>
  );
}
